// Libs

// Constants
import { DOCUMENT_SERVICE, SERVICE_VERSION_1, roles, tenants } from '../configurations/settings';

//interface

export var deleteDocument = function deleteDocument(companyId, customerDocMetaId, documentTypeId, payload) {
  var headers = {
    'Authorization': 'bearer ' + payload.clientToken
  };
  if (payload.requestorPayload) {
    headers['requestor'] = payload.requestorPayload;
  }
  if (payload.role === roles.SELLER_ROLE) {
    headers['x-tenant'] = tenants.MKOS;
  } else if (payload.tenantId === tenants.MOS_IND) {
    headers['x-tenant'] = payload.tenantId;
  }
  return payload.axiosInstance["delete"]("/".concat(DOCUMENT_SERVICE, "/").concat(SERVICE_VERSION_1) + "/user/docs/" + companyId + '?customerDocMetaId=' + customerDocMetaId + '&documentTypeId=' + documentTypeId, {
    headers: headers
  });
};